import { render } from "./EasySteps.vue?vue&type=template&id=6d7a61c2"
import script from "./EasySteps.vue?vue&type=script&lang=js"
export * from "./EasySteps.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__